import {RestApiService} from '../../Services/rest-api-service';
import { Component,EventEmitter,Input,OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from '../../Model/api-model';
import {Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';
import {Message,MessageService} from 'primeng/api';
import {MessageModule} from 'primeng/message';
import { ViewChild, ElementRef } from '@angular/core'
import { ProductPlan, Plan } from 'src/app/Model/product-model';
import { AppListResponse } from 'src/app/Model/apilistresponse-model';
import { App } from 'src/app/Model/app-model';
@Component({
  selector: 'app-updateapp',
  templateUrl: './app.updateapp.html'
})
export class UpdateAppComponent   {
  
 
  @Input() clientId:string;
  @Input() credId:string;
  @Input() appName:string;
  @Input() appCallBackUrl:string;
  @Input() appID:string;
  @Input() appSys:string;
  @Input() clientsecret:string;

  @Input() kid:string;
  @Input() jwksURL:string;

  @Input() chplProductId:string;

  @Input() chplProductName:string;

  @Output() appUpdatedData = new EventEmitter<any>();

  @ViewChild('deleteupdateappid') deleteupdateappid:ElementRef;
  @ViewChild('updateappid') updateappid:ElementRef;
  @ViewChild('verifyclientsecretid') verifyclientsecretid:ElementRef;


  @ViewChild('resetclientsecretid') resetclientsecretid:ElementRef;
  updateForm: FormGroup;
  loadAppRequest:boolean=false;
  deleteappCounter:number=1;
  errorMsgCallBackRequired="Call Back URL is Required";
  //updateappResponsedata:updateappResponse;
  updateMsgs: Message[]=[];
  appList:AppListResponse=new AppListResponse();
  confirmationPopup:boolean;
  clientsecretPopup:boolean;
  clientResetPopup :boolean;
  plans:ProductPlan;
  apisPlan:Plan[];
  constructor(private router: Router,private fb: FormBuilder, private messageService: MessageService,private restApi: RestApiService) {
  
  }
  ngOnInit() {
    this.messageService.clear('updateappKey');
    this.messageService.clear('appListKey');
  }
  disable_updateappbutton(){
    this.deleteupdateappid.nativeElement.disabled = true;
    this.updateappid.nativeElement.disabled = true;
    this.verifyclientsecretid.nativeElement.disabled = true;
    this.resetclientsecretid.nativeElement.disabled=true;
   }
   enable_updateappbutton(){
    this.deleteupdateappid.nativeElement.disabled = false;
    this.updateappid.nativeElement.disabled = false;
    this.verifyclientsecretid.nativeElement.disabled = false;
    this.resetclientsecretid.nativeElement.disabled=false;
   }
  getClientSecret(){
    this.clientsecret="";
    this.clientsecretPopup=true;
    this.disable_updateappbutton();
  }
  getClientSecretcancelConfirmation(){
    this.clientsecretPopup=false;
    this.enable_updateappbutton();
  }

  apigeeMsg=false;
  clientsecretResetConfirmation(){

   const sys= localStorage.getItem("appSys");

   
    if(sys=='apigee'){
      this.apigeeMsg=true;
    }else{
      this.apigeeMsg=false;
    }

    this.clientResetPopup=true;
    this.disable_updateappbutton();
  }
  clientsecretResetcancelConfirmation(){
    this.clientResetPopup=false;
    this.enable_updateappbutton();
  }
  deleteConfirmation(){
    this.confirmationPopup=true;
    this.disable_updateappbutton();
  }
  deletecancelConfirmation(){
    this.confirmationPopup=false;
    this.enable_updateappbutton();
  }
  deleteApp(){

    let currentRole;
    let payerCount=0;

    let devCount=0;

   if(localStorage.getItem("my_smart_App")){
      let myAPP=localStorage.getItem("my_smart_App");
  
      this.appList.appListView= JSON.parse(myAPP) as App[];

       for(let myapp of this.appList.appListView){
    
            if(this.appID==myapp.appID){
              currentRole=myapp.roleValue;
              console.log("current role is  "+currentRole);
            }

         
        console.log("my app id "+myapp.appID);

        
         
        console.log("my app name "+myapp.appName);
        console.log("my app role value "+myapp.roleValue);

          if(myapp.roleValue=='1'){
            payerCount=payerCount+1;
          }else{
            devCount=devCount+1;
          }

        }//end of for loop

      }//end of if
      else{

        localStorage.setItem("devStatus_qu","NA");
        localStorage.setItem("payerStatus_qu","NA");

      }//end of else

      console.log("dev count "+devCount);
      console.log("payer count "+payerCount);

     
      let devStatus_qu=localStorage.getItem("devStatus_qu");
      let payerStatus_qu =localStorage.getItem("payerStatus_qu");
   
   
      if(currentRole=='1' && payerCount==1 && payerStatus_qu=='0'){

          this.questionnireSubmission("PAYER"); 
          localStorage.setItem("payerStatus_qu","NA");

      }
      if(currentRole=='0' && devCount==1 && devStatus_qu=='0'){
            this.questionnireSubmission("THIRDDEV");
            localStorage.setItem("devStatus_qu","NA");
        
      }




    this.confirmationPopup=false;
    this.loadAppRequest=true;          
    this.restApi.App_deleteRequest(this.appID).subscribe(
      (data) =>  
      { 
     
     


        this.loadAppRequest=false; 
        this.messageService.clear('appListKey');
        this.enable_updateappbutton();
        if(data.errorMessage == null){
          localStorage.setItem("deleteappcounter",this.deleteappCounter.toLocaleString());
          localStorage.setItem("appName",this.appName);
          localStorage.setItem("Flag","Reason for Deleteapp");
          localStorage.setItem("is_first_load","yes");
          window.location.reload();
        }
        else{
          const obje_Json=JSON.parse(data.errorMessage);
           const s=Object.values(obje_Json.errors[0]);
           const errorToastupdatemessage = s.toString();
           this.messageService.clear('updateappKey');
           this.messageService.add({key: 'updateappKey',severity:'error',detail:errorToastupdatemessage});
        }
      },
      (error) =>{
        this.loadAppRequest=false;    
        this.enable_updateappbutton();         
        this.messageService.add({key: 'updateappKey',severity:'error', summary:this.errorMsgCallBackRequired, detail:'App Name'+this.appName});
    }
    )
  }

  questionnireSubmission(quType){
    //console.log(this.userValues);
  
    let fullName=localStorage.getItem("firstName")+" "+localStorage.getItem("lastName");
  
    let securityReview:boolean=false;
    let userConstent:boolean=false;
    let regReview:boolean=false;
  
    
   
    const requestJSON={"orgName": "NA",
                       "emailIdentifier": localStorage.getItem("email_ID"),
                       "appName":"NA",
                       "orgCountryCode": "NA", "roleName": "NA",
                       "phiDataText": "NA", "domainName": "NA",
                       "securityPracticesIndicator": securityReview, 
                       "regularlyReviewedIndicator": regReview, "userConsentIndicator": userConstent ,"deletionFlagCode":false,"firstName":localStorage.getItem("firstName"),"lastName":localStorage.getItem("lastName"),"status":"0","lastUpdateUserIdentifier":localStorage.getItem("email_ID"),"questionnaireTypeCode":quType,"questionnaireStatusText":"0","payerDataText":"NA","parentOrgName":"NA","registrantName":"NA"};
    console.log(requestJSON);
    this.restApi.ThirdPartyDevQuestionnaire_PutRequest(requestJSON).subscribe(
      (data)=>{
      
     
  
      },
      (error)=>{
    
        
    })
      
  }
  



  resetClientSecret(){
     this.loadAppRequest=true; 
     this.clientResetPopup=false;
     this.messageService.clear('updateappKey');
     this.disable_updateappbutton();

     const requestJSON={"clientId":this.clientId,"clientSecret":this.clientsecret,"credId":this.credId};
   
    
     this.restApi.updateAppResetClientSecret_PutRequest(this.appID,requestJSON).subscribe(
       (data) => 
       { 
           this.loadAppRequest=false;
           this.enable_updateappbutton();
           var pageElement = document.getElementById("myappviewscrollupdate");
           pageElement.scrollIntoView(true);
          
            if(data.status ==="Success"){


              this.messageService.add({key: 'updateappKey',severity:'info', detail:"Client Secret is successfully Reset."});
              this.messageService.add({key: 'updateappKey',severity:'info', detail:"Client Secret : "+ data.clientSecret});
             if(this.apigeeMsg){
              this.messageService.add({key: 'updateappKey',severity:'info', detail:"Client Id is successfully Reset."});
              this.messageService.add({key: 'updateappKey',severity:'info', detail:"Client Id : "+ data.clientId});
             }
          
            }
          else{
             this.messageService.add({key: 'updateappKey',severity:'error',detail:"Client Secret is not successfully Reset."});
          }
     },
       (error) =>{
         this.loadAppRequest=false; 
         this.enable_updateappbutton();            
         this.messageService.add({key: 'updateappKey',severity:'error', summary:this.errorMsgCallBackRequired, detail:'App Name'+this.appName});
     }
     )
    }

    
    verifyClientSecret(){
    // this.clientsecretPopup=false;
    this.clientsecretPopup=true;
     this.messageService.clear('updateappKey');
     this.loadAppRequest=true; 

     if(this.clientsecret!==null && this.clientsecret!==""){
     

     const clientsecretJson={"clientSecret":this.clientsecret,"credId":this.credId,"clientId":this.clientId};

     var pageElement = document.getElementById("myappviewscrollupdate");
     pageElement.scrollIntoView(true);
    

     this.restApi.updateAppVerifyClientSecret_PutRequest(clientsecretJson,this.appID).subscribe(
       (data) =>
         
       { 
           this.loadAppRequest=false;
          //  console.log("response client secret"+data.clientSecret);
            this.enable_updateappbutton();
            if(data.status ==="Success"){
              this.clientsecretPopup=false;
             // this.messageService.add({key: 'updateappKey',severity:'info', detail:"Client Secret :" + this.clientsecret});
               this.messageService.add({key: 'updateappKey',severity:'info', detail:"Client secret verified successfully"});
     
          }
          else{
            this.clientsecretPopup=false;
            this.messageService.add({key: 'updateappKey',severity:'error',detail:"Please enter the correct client secret"});
   
          }
         
     },
       (error) =>{
         this.loadAppRequest=false;  
         this.enable_updateappbutton();         
         this.messageService.add({key: 'updateappKey',severity:'error', summary:'Client secret not match please enter correct client secret '});  
     }
     )
    }
    else{
      this.loadAppRequest=false;
      this.messageService.clear('updateappKey');
      this.enable_updateappbutton();
      this.messageService.add({key: 'updateappKey',severity:'error', summary:'Please enter the client secret'});
    }
    }

    onlyLettersAndNumbersandHypen(str) {
      return /^[A-Za-z0-9-]*$/.test(str);
    }
  updateApp(){
  
    if(this.appCallBackUrl.trim()=='' || this.appCallBackUrl.trim()==null){


      return true;
    }

    const sys= localStorage.getItem("appSys");

   
    
  if(sys=='apigee'){

      if(this.chplProductId.trim()=='' || this.chplProductId.trim()==null ||this.chplProductName.trim()=='' || this.chplProductName.trim()==null || this.jwksURL.trim()=='' || this.jwksURL.trim()==null || this.appCallBackUrl.trim()=='' || this.appCallBackUrl.trim()==null || this.kid.trim()=='' || this.kid.trim()==null){


        return true;
      }

      this.kid=this.kid.split(' ').join('');

      let tempKid=this.kid;

      let sizeKid=tempKid.length;

     
      let checkKid=this.onlyLettersAndNumbersandHypen(tempKid);
      //window.alert("size:check "+size+check)
          if(sizeKid<5 || sizeKid>50 || (!checkKid)){
          
            window.alert("The KID should have a minimum of 5 characters and a maximum of 30 characters. No special characters are allowed except '-', and spaces will be removed from the KID.");
            return true;
          }// end of minimum, maximum and characters and special characters check

    


    }
  
   
  
    this.loadAppRequest=true;
    this.messageService.clear('updateappKey');
    this.appCallBackUrl=this.appCallBackUrl.trim();
    

    //document.getElementById('textbox_id').i


   
  

    
    let validURL=this.appCallBackUrl.toLowerCase();

    if(validURL.startsWith("http://") || validURL.startsWith("https://")){

    }else{

     
      this.loadAppRequest =false;
   
      this.messageService.clear('updateappKey');
      
      this.messageService.add({key: 'updateappKey',severity:'error',detail:"Invalid Callback URL. Please note the Callback URL should start with http:// or https://"});


      return true;
    }

    
    
    
    
    
    
    
    
    this.disable_updateappbutton();
    if(this.appCallBackUrl!==null && this.appCallBackUrl!==""){ 
    const requestJSON={"appName":this.appName,"callBackUrl":this.appCallBackUrl,"kid":this.kid,"jwksURL":this.jwksURL,"chplProductName":this.chplProductName,"chplProductId":this.chplProductId};
    

    
    this.restApi.updateApp_PutRequest(requestJSON,this.appID).subscribe(
      (data) =>
        
      { 
          this.loadAppRequest=false;
          this.enable_updateappbutton();
           if(data.errorMessage ==null){

           // const data = { message: 'Hello from child!' };
           
           //console.log("update done")

             // this.messageService.add({key:'updateappKey',severity:'info', detail:'App Name : '+ this.appName +"  successfully updated."});
             
             
              
                this.appUpdatedData.emit(requestJSON);
             
        
            }
         else{
          var pageElement = document.getElementById("myappviewscrollupdate");
          pageElement.scrollIntoView(true);
           console.log(data.errorMessage);
         //  const obje_Json=JSON.parse(data.errorMessage);
          //  const s=Object.values(obje_Json.errors[0]);
           // const errorToastupdatemessage = s.toString();
            this.messageService.add({key:'updateappKey',severity:'error',detail:data.errorMessage});

         }

        
        
    },
      (error) =>{
        var pageElement = document.getElementById("myappviewscrollupdate");
          pageElement.scrollIntoView(true);
        this.loadAppRequest=false;    
        this.enable_updateappbutton();         
        this.messageService.add({key:'updateappKey',severity:'error', summary:'Call Back URL is Required', detail:'App Name'+this.appName});
    })
   }//end of if
   else{
    var pageElement = document.getElementById("myappviewscrollupdate");
    pageElement.scrollIntoView(true);
    this.loadAppRequest=false;
    this.enable_updateappbutton();
    this.messageService.add({key:'updateappKey',severity:'error', summary:'Callback URL is required.', detail:''});
   }//end of else
  }//end of update method  

pathInfo;

  ngOnChanges() {
    //this.childFunction();
    //console.log("selected app "+this.appID);
  //  this.showDivforUnsub=true;
  //  this.showSpiner=false;
  // this.mySubscriptionForAnApp(); 
     // console.log("chanegs")
     
     
     this.pathInfo=localStorage.getItem("path");
     this.messageService.clear('updateappKey');
     const sys= localStorage.getItem("appSys");

   
  }











  ngAfterViewChecked(){
    document.querySelectorAll('table')
    .forEach((input) => {
     // console.log(input.getAttribute("role"));
       if(input.getAttribute("role")=="grid"){
        input.removeAttribute("role");
       }
     
    });

  }




}
